import { process } from '../data/site';
import Reveal from './Reveal';
import SectionHead from './SectionHead';

function ProcessSteps() {
  return (
    <section className="bg-ink py-24 text-white md:py-32">
      <div className="wrap">
        <SectionHead
          eyebrow="How it works"
          title="A calm, clear"
          accent="process."
          light
          text="From the first conversation to the final walkthrough, you always know what happens next."
        />
        <div className="grid gap-px bg-white/10 md:grid-cols-4">
          {process.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08} className="bg-ink p-8 transition hover:bg-white/5">
              <p className="h-display text-6xl text-clay">{s.n}</p>
              <h3 className="mt-6 text-lg font-bold">{s.title}</h3>
              <p className="mt-3 text-sm leading-7 text-white/60">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSteps;
